/**
 * Trunnion AI - 404 Not Found Page
 */

import { useNavigate } from 'react-router-dom';
import { Shield, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { ROUTES } from '@/config/routes';

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center text-center">
      <div className="mb-6 flex h-20 w-20 items-center justify-center rounded-2xl bg-trunnion-gold-500/10">
        <Shield className="h-10 w-10 text-trunnion-gold-500" />
      </div>
      <h1 className="text-4xl font-bold text-white">404</h1>
      <p className="mt-2 text-lg text-trunnion-slate-300">Page Not Found</p>
      <p className="mt-1 text-sm text-trunnion-slate-400">
        The requested resource does not exist or you do not have access.
      </p>
      <Button
        className="mt-6"
        icon={<ArrowLeft className="h-4 w-4" />}
        onClick={() => navigate(ROUTES.DASHBOARD)}
      >
        Return to Dashboard
      </Button>
    </div>
  );
}
